import React, { useState, useEffect } from 'react';
import { CheckCircle, Server, Zap, Shield, Globe, ChevronLeft, ChevronRight } from 'lucide-react';
import { getStorageUrl } from '../utils/imageUrlUpdater';

const VPSEurope: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);

  // Set page title and canonical URL
  useEffect(() => {
    document.title = 'VPS Châu Âu - VMon Cloud';
    
    // Set canonical URL
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = 'https://vmon.vn/vps-chau-au';
    document.head.appendChild(canonical);
    
    return () => {
      if (canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      }
      document.title = 'VMon Cloud - Dịch vụ VPS và Hosting chất lượng cao';
    };
  }, []);

  const plans = [
    {
      name: 'EU - 1 GB',
      price: '115,000',
      originalPrice: '150,000',
      cpu: '1 VCpu',
      ram: '1GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'EU - 2 GB',
      price: '155,000',
      originalPrice: '200,000',
      cpu: '1 VCpu',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'EU - 2 GB - 2 CPU',
      price: '175,000',
      originalPrice: '250,000',
      cpu: '2 VCpu',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'EU - 4 GB',
      price: '315,000',
      originalPrice: '415,000',
      cpu: '2 VCpu',
      ram: '4GB',
      storage: '60GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'EU - 8 GB',
      price: '575,000',
      originalPrice: '800,000',
      cpu: '4 VCpu',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'EU - 16 GB',
      price: '915,000',
      originalPrice: '1,500,000',
      cpu: '8 VCpu',
      ram: '16GB',
      storage: '180GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    }
  ];

  const specifications = [
    { label: 'Datacenter', value: 'Amsterdam, Frankfurt, London, Paris' },
    { label: 'Network', value: '1Gbps Port Speed' },
    { label: 'Storage', value: '100% SSD NVMe' },
    { label: 'Virtualization', value: 'KVM' },
    { label: 'Control Panel', value: 'VMon' },
    { label: 'Setup Time', value: 'Instant' },
    { label: 'IPv4', value: '1 Dedicated IP' },
    { label: 'Backup', value: 'Weekly Automatic' }
  ];

  const additionalPricing = [
    { item: '1 IP', price: '50,000 VNĐ / Tháng' },
    { item: '1 VCpu', price: '50,000 VNĐ / Tháng' },
    { item: '1 GB Ram', price: '50,000 VNĐ / Tháng' },
    { item: '10GB ổ cứng SSD NVMe', price: '30,000 VNĐ / Tháng' }
  ];

  const advantages = [
    {
      icon: Server,
      title: 'VPS EU GIÁ RẺ',
      description: 'VPS ở khắp châu âu bao gồm cả nước Anh với giá rẻ, đảm bảo hiệu năng, tiết kiệm chi phí nhất.'
    },
    {
      icon: Shield,
      title: 'HOÀN TOÀN MIỄN PHÍ DDOS',
      description: 'Giờ đây, khi có những nguy cơ xâm nhập vào tài nguyên hay dữ liệu của bạn, chúng tôi sẽ ngăn chặn nó giúp bạn, và hoàn toàn miễn phí.'
    },
    {
      icon: Zap,
      title: 'CÀI ĐẶT TỰ ĐỘNG',
      description: 'Quá trình đăng ký và triển khai dịch vụ VPS EU diễn ra nhanh chóng và hoàn toàn tự động. Bạn có thể tạo và sử dụng vps chỉ với một click.'
    },
    {
      icon: Globe,
      title: 'WINDOWS VPS EUROPE',
      description: 'VMon Cloud hỗ trợ nhiều hệ điều hành windows và linux. Windows 10, Windows Server 2012r2, Windows Server 2016, Windows server 2019, Windows server 2022. Ngoài ra VMon Cloud còn hỗ trợ CentOS, Ubuntu Server.'
    }
  ];

  const benefits = [
    {
      icon: Server,
      title: 'DATA TRANSFER KHÔNG GIỚI HẠN',
      description: 'Với VPS EU của VMon Cloud bạn không bị giới hạn Data Transfer, từ đó giúp khai thác tối đa hiệu suất của vps mà không lo lắng chạm ngưỡng dữ liệu trao đổi trong 1 tháng.'
    },
    {
      icon: Shield,
      title: 'CHÍNH SÁCH MINH BẠCH',
      description: 'Tất cả các thông tin liên quan đến điều khoản và chính sách của VMon Cloud có nội dung thể hiện đầy đủ, chi tiết và được công khai trên trang chủ giúp cho khách hàng có được sự an tâm tuyệt đối.'
    },
    {
      icon: Zap,
      title: 'TOÀN QUYỀN QUẢN TRỊ MÁY CHỦ',
      description: 'Quý khách hàng có thể chủ động và toàn quyền trong thao tác, kiểm soát hoạt động của máy chủ với giao diện trang quản trị được thiết kế đơn giản, đầy đủ tính năng cần thiết.'
    },
    {
      icon: Globe,
      title: 'HỖ TRỢ NHIỆT TÌNH, ĐỒNG HÀNH CÙNG BẠN',
      description: 'Chúng tôi luôn ở đây! Đội ngũ kỹ thuật viên của chúng tôi thường trực 24/7 để hỗ trợ bạn.'
    }
  ];

  const faqItems = [
    {
      question: 'VPS EU là gì?',
      answer: 'Nhằm đáp ứng tối đa nhu cầu của quý khách sử dụng Server và VPS. VMon Cloud chính thức đưa VPS EU vào khai thác và sử dụng. VPS Châu Âu là máy chủ ảo có địa chỉ IP tại các nước thuộc liên minh châu âu cũ như Anh, Pháp, Đức, Ba Lan... cài sẵn Windows/Linux trên hạ tầng phần cứng hiện đại, sử dụng ổ SSD NVMe tốc độ cao, với băng thông tốc độ 1Gbps không giới hạn.'
    },
    {
      question: 'Thuê VPS Châu Âu - VPS EUROPE ở đâu?',
      answer: 'Hiện tại VPS là sản phẩm được khá nhiều đơn vị cung cấp. Bạn có thể lựa chọn thuê VPS Châu Âu-VPS EU ở bất cứ nơi nào miễn là bạn cảm thấy phù hợp với nhu cầu và ngân sách của bản thân. VMon Cloud là một trong những đơn vị cung cấp vps chất lượng với giá cả hấp dẫn, bạn có thể tham khảo.'
    },
    {
      question: 'VPS nước ngoài là gì?',
      answer: 'VPS nước ngoài là những VPS có datacenter được đặt tại nước ngoài, nước ngoài được hiểu là các quốc gia bên ngoài lãnh thổ Việt Nam. Ví dụ: VPS Singapore, VPS Mỹ, VPS Châu Âu… được gọi là VPS nước ngoài.'
    },
    {
      question: 'VPS nước ngoài có tốt hơn VPS Việt Nam?',
      answer: 'VPS nước ngoài là cụm từ có ý nghĩa chỉ các VPS có địa chỉ IP đặt ở một nơi ngoài lãnh thổ Việt Nam như VPS Anh, VPS Đức, VPS Singapore được gọi là một VPS nước ngoài. VPS nước ngoài thường có chi phí rẻ hơn VPS Việt Nam, điều này có thể lý giải do chi phí vận hành Datacenter của VPS nước ngoài thấp hơn.'
    },
    {
      question: 'Làm cách nào để tôi có thể kết nối với dịch vụ Cloud Server của mình?',
      answer: 'Tất cả Cloud Server đều có quyền truy cập VNC trực tiếp cho phép bạn truy cập máy chủ đám mây bên ngoài hệ điều hành. Vì vậy bạn có thể truy cập đến Cloud Server của mình thông qua SSH hoặc Remote Desktop tùy thuộc vào hệ điều hành được cài đặt trên Cloud Server.'
    },
    {
      question: 'Một Cloud Server có thể host được bao nhiêu website?',
      answer: 'Đối với Cloud Server không giới hạn website bạn có thể host. Bạn có thể thêm bao nhiêu website tùy ý miễn sao tài nguyên trên Cloud Server đủ để lưu trữ. Và còn tùy thuộc vào gói Cloud Server của bạn đăng ký sẽ có lượng tài nguyên nhiều hay ít.Đối với Cloud Server không giới hạn website bạn có thể host. Bạn có thể thêm bao nhiêu website tùy ý miễn sao tài nguyên trên Cloud Server đủ để lưu trữ. Và còn tùy thuộc vào gói Cloud Server của bạn đăng ký sẽ có lượng tài nguyên nhiều hay ít.'
    }
  ];

  const testimonials = [
    getStorageUrl('feedback/feedback_1.jpg'),
    getStorageUrl('feedback/feedback_2.jpg'),
    getStorageUrl('feedback/feedback_3.jpg'),
    getStorageUrl('feedback/feedback_4.jpg'),
    getStorageUrl('feedback/feedback_5.jpg'),
    getStorageUrl('feedback/feedback12.jpg'),
    getStorageUrl('feedback/feedback16.jpg'),
    getStorageUrl('feedback/feedback17.jpg')
  ];

  const galleryImages = [
    {
      src: getStorageUrl('panel/Giam-Sat-VPS.PNG'),
      title: "Giám Sát VPS",
      description: "Theo Dõi VPS Một Cách Thuận Tiện Từ CPU, RAM, Disk, Network."
    },
    {
      src: getStorageUrl('panel/Quan-ly-vps.PNG'),
      title: "Quản Lý VPS",
      description: "Quản lý các thông tin vps đầy đủ và tiện lợi."
    },
    {
      src: getStorageUrl('panel/quan-ly-hoa-don.PNG'),
      title: "Quản Lý Hoá Đơn",
      description: "Quản lý hoá đơn đầy đủ và minh bạch."
    },
    {
      src: getStorageUrl('panel/Mua-VPS.PNG'),
      title: "MUA VPS",
      description: "Mua VPS thuận tiện với giao diện one click."
    },
    {
      src: getStorageUrl('panel/giao-dien-dien-thoai.PNG'),
      title: "Quản lý vps trên điện thoại",
      description: "Quản lý vps trên điện thoại thuận tiện, dễ sử dụng."
    },
    {
      src: getStorageUrl('panel/lich-su-so-du.PNG'),
      title: "Số Dư Tài Khoản",
      description: "Quản lý số dư tài khoản thuận tiện và minh bạch."
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <Globe className="h-8 w-8 mr-2" />
              <span className="text-2xl font-semibold">VPS Châu Âu</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              VPS Châu Âu
            </h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              VPS Châu Âu - VPS UK, VPS Germany, VPS France, VPS Poland với 100% SSD NVMe, 
              miễn phí Anti-DDOS. Giá ưu đãi chỉ từ 115.000đ/tháng.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Zap className="h-4 w-4 mr-2" />
                Tốc độ cao
              </div>
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Shield className="h-4 w-4 mr-2" />
                100% SSD NVMe
              </div>
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Server className="h-4 w-4 mr-2" />
                99.9% Uptime
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">BẢNG GIÁ CLOUD VPS UK, VPS Germany, VPS France, VPS Poland</h2>
            </div>
          {/* Alert */}
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-8 rounded">
            <p className="font-bold">Ưu đãi hấp dẫn giảm ngay 40% khi gia hạn 3 năm.</p>
            <p>Giảm 20% khi gia hạn 1 năm, giảm 10% khi gia hạn 6 tháng, giảm 5% khi gia hạn 3 tháng.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.slice(0, 3).map((plan, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                  plan.popular ? 'ring-2 ring-blue-500' : ''
                }`}
              >
                {plan.popular && (
                  <div className="bg-blue-500 text-white text-center py-2 font-semibold">
                    BÁN CHẠY
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <div className="mb-4">
                    <div className="flex items-baseline">
                      <span className="text-3xl font-bold text-blue-600">{plan.price}</span>
                      <span className="text-gray-600 ml-1"> VNĐ/Tháng</span>
                    </div>
                    <div className="text-sm text-gray-500 line-through">{plan.originalPrice} VNĐ</div>
                  </div>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className="text-gray-600">CPU:</span>
                      <span className="font-semibold">{plan.cpu}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">RAM:</span>
                      <span className="font-semibold">{plan.ram}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Storage:</span>
                      <span className="font-semibold">{plan.storage}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Bandwidth:</span>
                      <span className="font-semibold">{plan.bandwidth}</span>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a 
                    href="https://cloud.vmon.vn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center ${
                      plan.popular
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Đăng Ký
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {plans.slice(3, 6).map((plan, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                  plan.popular ? 'ring-2 ring-blue-500' : ''
                }`}
              >
                {plan.popular && (
                  <div className="bg-blue-500 text-white text-center py-2 font-semibold">
                    BÁN CHẠY
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <div className="mb-4">
                    <div className="flex items-baseline">
                      <span className="text-3xl font-bold text-blue-600">{plan.price}</span>
                      <span className="text-gray-600 ml-1"> VNĐ/Tháng</span>
                    </div>
                    <div className="text-sm text-gray-500 line-through">{plan.originalPrice} VNĐ</div>
                  </div>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className="text-gray-600">CPU:</span>
                      <span className="font-semibold">{plan.cpu}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">RAM:</span>
                      <span className="font-semibold">{plan.ram}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Storage:</span>
                      <span className="font-semibold">{plan.storage}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Bandwidth:</span>
                      <span className="font-semibold">{plan.bandwidth}</span>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a 
                    href="https://cloud.vmon.vn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center ${
                      plan.popular
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Đăng Ký
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Pricing */}
          <div className="mt-12 bg-white rounded-lg shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              Bảng Giá Đăng Ký Thêm CPU, RAM, Ổ Cứng, IP
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {additionalPricing.map((item, index) => (
                <div key={index} className="text-center p-4 border border-gray-200 rounded-lg">
                  <div className="flex items-center justify-center mb-2">
                    <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                    <span className="font-semibold text-gray-900">{item.item}</span>
                  </div>
                  <p className="text-blue-600 font-medium">{item.price}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              NHỮNG ƯU ĐIỂM VƯỢT TRỘI CỦA CLOUD VPS CHÂU ÂU - VPS EU TẠI VMon Cloud
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <advantage.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{advantage.title}</h3>
                <p className="text-gray-600 text-sm">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              LỢI ÍCH KHI MUA VPS UK, VPS Germany, VPS France, VPS Poland GIÁ RẺ TẠI VMon Cloud
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <benefit.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Feedback Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">KHÁCH HÀNG NÓI GÌ VỀ CHÚNG TÔI?</h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              Khách hàng là trung tâm của mọi hoạt động của chúng tôi, và chúng tôi luôn cố gắng lắng nghe ý kiến phản hồi để nâng cao chất lượng sản phẩm và dịch vụ. Cam kết này giúp chúng tôi đáp ứng tốt hơn nhu cầu và mong muốn của khách hàng, mang lại sự hài lòng và niềm tin tuyệt đối từ phía khách hàng.
            </p>
          </div>

          {/* Testimonial Slider */}
          <div className="relative max-w-4xl mx-auto">
            {/* Main Slider */}
            <div className="relative overflow-hidden rounded-lg shadow-lg bg-white">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="w-full flex-shrink-0 flex justify-center items-center p-4">
                    <img
                      src={testimonial}
                      alt={`Customer Feedback ${index + 1}`}
                      className="max-w-full max-h-96 object-contain rounded-lg shadow-sm"
                    />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200"
              >
                <ChevronLeft className="h-6 w-6 text-gray-700" />
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200"
              >
                <ChevronRight className="h-6 w-6 text-gray-700" />
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-200 ${
                    index === currentSlide 
                      ? 'bg-blue-600 scale-110' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Thư Viện Hình Ảnh</h2>
          <p className="text-lg text-gray-600 mb-12 text-center">
            Quản lý tài khoản, tạo mới và giám sát khi Thuê VPS Việt Nam dễ dàng với trang panel hiện đại, thân thiện dễ sử dụng.
          </p>
          
          {/* Gallery Slider */}
          <div className="relative max-w-4xl mx-auto">
            <div className="overflow-hidden rounded-lg bg-gray-100">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentGallerySlide * 100}%)` }}
              >
                {galleryImages.map((image, index) => (
                  <div key={index} className="w-full flex-shrink-0 p-8">
                    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                      <img
                        src={image.src}
                        alt={image.title}
                        className="w-full h-64 object-contain bg-gray-50"
                      />
                      <div className="p-6 text-center">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{image.title}</h3>
                        <p className="text-gray-600">{image.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation Buttons */}
            <button
              onClick={prevGallerySlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronLeft className="h-6 w-6 text-gray-600" />
            </button>
            <button
              onClick={nextGallerySlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronRight className="h-6 w-6 text-gray-600" />
            </button>
            
            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentGallerySlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentGallerySlide ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Specifications Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Thông Số Kỹ Thuật</h2>
            <p className="text-lg text-gray-600">Chi tiết cấu hình và tính năng</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {specifications.map((spec, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-4">
                <div className="text-sm text-gray-600 mb-1">{spec.label}</div>
                <div className="font-semibold text-gray-900">{spec.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Europe VPS */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Tại Sao Chọn VPS Châu Âu?</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Tuân thủ GDPR</h3>
              <p className="text-gray-600">
                Đầy đủ tuân thủ quy định GDPR về bảo vệ dữ liệu cá nhân
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Zap className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Kết nối tốt</h3>
              <p className="text-gray-600">
                Kết nối internet tốc độ cao đến các quốc gia châu Âu và toàn cầu
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Server className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hạ tầng hiện đại</h3>
              <p className="text-gray-600">
                Datacenter tier-3 với công nghệ tiên tiến và nguồn điện ổn định
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Những câu hỏi thường gặp về máy chủ ảo VPS EU
            </h2>
          </div>

          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <details key={index} className="bg-white rounded-lg p-6 shadow">
                <summary className="font-semibold text-gray-900 cursor-pointer hover:text-blue-600">
                  {item.question}
                </summary>
                <p className="mt-4 text-gray-600">{item.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Cùng nhau, Trực tuyến.
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Chúng tôi ở đây giúp các bạn có thể làm việc online một cách hiệu quả nhất.
          </p>
          <a 
            href="https://cloud.vmon.vn/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors inline-block"
          >
            Bắt đầu ngay
          </a>
        </div>
      </section>
    </div>
  );
};

export default VPSEurope;